import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import type { ProviderCode } from '@patrianna/shared-patrianna-types/store/ProviderModule'
import { usePathname } from 'next/navigation'

import GameDescription from 'components/GameContentRender'
import GameInfoMedia from 'components/GameInfoMedia'
import Page from 'components/Page'
import { useRouterPushWithCallback } from 'containers/NavigationProvider'
import { ImageType } from 'src/components/Picture/Picture.types'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { startExternalGameFlow } from 'store/modules/slotGameFlow/actions'
import { isLoggedInSelector } from 'store/modules/user/selectors'
import type { SupportedCurrencies } from 'types/currencies'
import { slugToTitle } from 'utils/slugToTitle'

import GameInfo from './components/GameInfo'
import PlayGameButton from './components/PlayGameButton'
import classes from './styles.module.scss'

type Props = {
  activeCurrency: SupportedCurrencies
  gameProduct: GameProduct
  pageContent?: string
  providerCodes: ProviderCode[]
}

function GameLandingPage(props: Props) {
  const routerPush = useRouterPushWithCallback()
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const dispatch = useAppDispatch()
  const pathname = usePathname()
  const testIdType = slugToTitle(pathname.split('/').filter(Boolean)[0])

  return (
    <Page className={classes.page}>
      <div hidden data-testid='game-title'>
        {props.gameProduct.title}
      </div>
      <div hidden data-testid='game-type'>
        {testIdType}
      </div>
      <div className={classes.info}>
        <GameInfoMedia
          imagePath={'backgrounds'}
          imageType={ImageType.BACKGROUND}
          className={classes.imageContainer}
          gameProduct={props.gameProduct}
          dataTestId='game-banner'
          isGameDescription
        />
        {/* Volatility, Min / Max, Orientation, Top Prize */}
        <GameInfo
          isLoggedIn={isLoggedIn}
          gameProduct={props.gameProduct}
          activeCurrency={props.activeCurrency}
          providerCodes={props.providerCodes}
        />
      </div>

      <GameDescription pageContent={props.pageContent}>
        <PlayGameButton
          className={classes.playGameButton}
          gameProduct={props.gameProduct}
          activeCurrency={props.activeCurrency}
          startExternalGameFlow={(game, currency) =>
            dispatch(startExternalGameFlow(game, currency, routerPush, { refererPath: 'gameDescription' }))
          }
        />
      </GameDescription>
    </Page>
  )
}

export default GameLandingPage
